module.exports = __webpack_public_path__ + "static/monopoly-logo-d088f81a885fea30ca90aee956a2832f.png";